module.exports = __webpack_public_path__ + "static/img/im-bg.81263867.png";